import React from "react";
import { Helmet } from 'react-helmet';
import CountUp from 'react-countup';
import Footer from "./Footer";
import Header from "./Header";
import ScrollAnimation from 'react-animate-on-scroll';

const getYearsOfExperience = () => {
    const startDate = new Date(2017, 6, 10);
    const today = new Date();
    let years = today.getFullYear() - startDate.getFullYear();
    const hasAnniversaryPassed =
        today.getMonth() > startDate.getMonth() ||
        (today.getMonth() === startDate.getMonth() && today.getDate() >= startDate.getDate());

    if (!hasAnniversaryPassed) {
        years -= 1;
    }

    return Math.max(years, 0);
};

class App extends React.Component {
    render() {
        const myStyleone = {
            background: "#1f1f22",
            width: "100%",
            zIndex: 2,
        };

        const mystylethree = {
            backgroundImage:
                "url('../assets/img/bg/why_bg_1.png')",
            backgroundRepeat: 'no-repeat'
        };
        const yearsOfExperience = getYearsOfExperience();

        return (
            <div>
                <Helmet>
                    <title>About Oengines | Game, Web and App Development Company</title>
                    <meta
                        name="description"
                        content="Learn about Oengines, a Surat-based development team building games, mobile apps, web platforms, UI/UX, backend systems, and ongoing product support."
                    />
                    <link rel="canonical" href="https://www.oengines.com/about" />
                    <link rel="stylesheet" href="../../assets/css/Slick_Cdn/Slic-min.css" />
                    <script src="../assets/js/particles-min.js"></script>
                    <script src="../assets/js/script.js" type="text/Javascript"></script>
                </Helmet>
                {/* <div className="loader" ><span>Loading...</span></div> */}
                <Header />
                <div className="breadcumb-wrapper" style={myStyleone}>
                    <div className="container">
                        <div className="breadcumb-content">
                            <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                <h1 className="breadcumb-title">About Us</h1>
                            </ScrollAnimation>
                            <ul className="breadcumb-menu">
                                <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                </ScrollAnimation>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="mt-60" id="about-sec">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-xl-6 mb-30 mb-xl-0">
                                <div className="img-box1">
                                    <div className="img1"><img src="assets/img/normal/faq_1_1.png" alt="About" /></div>
                                    <div className="year-counter">
                                        <img src="../assets/img/theme-img/yearexperience.svg" alt="Years of experience" />
                                        <h3 className="year-counter_number "><span className="counter-number" id="foo"><CountUp end={yearsOfExperience} />+</span></h3>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="ps-xxl-4 ms-xl-3 p-4">
                                    <div className="title-area mb-35"><span className="sub-title"><img
                                        src="assets/img/theme-img/title_shape_1.svg" alt="shape" />About Oengines</span>
                                        <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                            <div className="d-flex our-sgv-flex">
                                                <div className="abt-svg-icon">
                                                    <img src="../assets/img/icon/megaphone.svg" alt="Megaphone" />
                                                </div>
                                                <h2 className="sec-title fadeInLeft">
                                                    <span className="">Who we are</span></h2>
                                            </div>
                                        </ScrollAnimation>
                                    </div>
                                    <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                        <p className="mt-n2 mb-25">Oengines is a product development studio focused on game development, mobile applications, web platforms, UI/UX design, backend engineering, and long-term product support. We help businesses turn clear requirements into reliable digital products.</p></ScrollAnimation>
                                    <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                        <p className="mt-n2 mb-25">Our team works across planning, design, development, testing, deployment, and maintenance, with an emphasis on clean execution, practical technology choices, and dependable communication throughout the project lifecycle.</p></ScrollAnimation>
                                    <div className="about-feature-wrap">
                                        <div className="about-feature">
                                            <div className="about-feature_icon"><img src="../assets/img/icon/about_feature_1_1.svg"
                                                alt="Icon" /></div>
                                            <div className="media-body">
                                                <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                                    <h3 className="about-feature_title">Product-Focused Delivery</h3>
                                                </ScrollAnimation>
                                                <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                                    <p className="about-feature_text">Built around scope, quality, and launch readiness</p>
                                                </ScrollAnimation>
                                            </div>
                                        </div>
                                        <div className="about-feature">
                                            <div className="about-feature_icon"><img src="../assets/img/icon/about_feature_1_2.svg"
                                                alt="Icon" /></div>
                                            <div className="media-body">
                                                <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                                    <h3 className="about-feature_title">Experienced Team</h3>
                                                </ScrollAnimation>
                                                <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                                    <p className="about-feature_text">Designers, developers, testers, and support specialists</p>
                                                </ScrollAnimation>
                                            </div>
                                        </div>
                                    </div>
                                    <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                        <div className="btn-group"><a href="tel:+02614054978" className="as-btn style3">Call now<i
                                            className="fa-regular fa-arrow-right ms-2"></i></a>
                                            <div className="call-btn">
                                                <div className="play-btn"><i className="fas fa-phone"></i></div>
                                                <div className="media-body"  ><span className="btn-text">Call Us On:</span> <a
                                                    href="tel:+02614054978" className="btn-title">(0261) - 4054978</a></div>
                                            </div>
                                        </div></ScrollAnimation>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="space" style={mystylethree}>
                    <div className="container">
                        <div className="row align-items-center flex-row-reverse">
                            <div className="col-xxl-7 col-xl-6 mb-30 mb-xl-0 new-space-bottom">
                                <div className="img-box2">
                                    <div className="img1"><img src="assets/img/normal/why_1_1.jpg" alt="Why choose Oengines" /></div>
                                </div>
                            </div>
                            <div className="col-xxl-5 col-xl-6">
                                <div className="title-area mb-35">
                                    <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                        <span className="sub-title"><img
                                            src="assets/img/theme-img/title_shape_1.svg" alt="shape" />WHY CHOOSE US</span>
                                    </ScrollAnimation>
                                    <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                        <h2 className="sec-title">Get in Touch with Us for the <span className="text-theme">Best Work!</span></h2>
                                    </ScrollAnimation>
                                </div>
                                <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                    <p className="mt-n2 mb-30 new_get_in_touch">We assign the right mix of developers, designers, testers, and project support based on the needs of each product, so the work stays focused from discovery through release.</p>
                                </ScrollAnimation>
                                <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                    <p className="mt-n2 mb-30 new_get_in_touch">Our mission is to create useful, maintainable software that helps clients ship faster, improve operations, and grow their digital products with confidence.</p>
                                </ScrollAnimation>
                                <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                    <p className="mt-n2 mb-30 new_get_in_touch">Oengines provides game, app, web, backend, UI/UX, testing, and live operations services for startups, agencies, and businesses that need dependable technical execution.</p>
                                </ScrollAnimation>
                                <div className="two-column">
                                    <div className="checklist style2">
                                        <ul>
                                            <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                                <li className="mb-4"><i className="far fa-check"></i> Reliable solutions</li>
                                            </ScrollAnimation>
                                            <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                                <li className="mb-4"><i className="far fa-check"></i> Ongoing product support</li>
                                            </ScrollAnimation>
                                            <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                                <li className="mb-4"><i className="far fa-check"></i>Business-focused execution</li>
                                            </ScrollAnimation>
                                        </ul>
                                    </div>
                                    <div className="checklist style2">
                                        <ul>
                                            <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                                <li className="mb-4"><i className="far fa-check"></i>High-quality standards</li>
                                            </ScrollAnimation>
                                            <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                                <li className="mb-4"><i className="far fa-check"></i> Skilled technical team</li>
                                            </ScrollAnimation>
                                            <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                                <li className="mb-4"><i className="far fa-check"></i>Practical, maintainable solutions</li>
                                            </ScrollAnimation>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}

export default App;
